import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductService } from 'src/app/services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { VolumetricValidation, regexPattern } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import * as $ from 'jquery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';
import { Utilities } from 'src/app/models/utilities';
import { GeoService } from 'src/app/services/geo.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditStatesComponent {
  stateform: FormGroup;
  stateId: number;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted = false;
  countryList = [];

  constructor(
    private formBuilder: FormBuilder,
    private appCoreService: AppCoreService,
    private geoService: GeoService,
    private route: ActivatedRoute,
    private productService: ProductService,
    private router: Router,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title,
    private utilities: Utilities,
  ) {
    titleService.setTitle('States');
  }

  ngOnInit() {
    this.stateId = this.route.snapshot.params['id'];
    this.stateform = this.formBuilder.group({
      ddlCountry: [null, Validators.compose([Validators.required])],
      txtStateCode: [{ value: null, disabled: true }, Validators.compose([Validators.required, Validators.maxLength(3)])],
      txtStateName: [null, Validators.compose([Validators.required, Validators.maxLength(70)])],
      txtGstAlise: [null,Validators.compose([Validators.maxLength(5)])], 
      txtStatus: [true]
    });
    this.checkPermission();
    this.bindCountries();
    this.getStateById();
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'States');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  getStateById() {
    try {
      this.ngxLoaderService.start();
      this.geoService.getStateById(this.stateId).subscribe((res) => {
        if (res?.success) {
          this.ngxLoaderService.stop();
          // console.log("getstatebyid", res.data);
          const stateData = res?.data[0];

          this.stateform.patchValue({
            ddlCountry: this.countryList.find(x => x.id === stateData?.countryid)?.isocode,
            txtStateCode: stateData?.code,
            txtStateName: stateData?.name,
            txtGstAlise: stateData?.gstalise,
            txtStatus: stateData?.isactive
          });
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
        }
      });
    } catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  updateState() {
    try {
      if (!this.permConfig.isAddAllowed) {
        this.warningDialog('No access to Add.');
        return;
      }
      this.isFormSubmitted = true;
      if (this.permConfig.isAddAllowed && this.stateform.valid) {

        const selectedIsoCode = this.stateform.get('ddlCountry').value;
        const selectedCountry = this.countryList.find((country: any) => country.isocode === selectedIsoCode);
        const stateCode = this.stateform.get('txtStateCode').value;

        const requestObj = {
          id: this.stateId,
          countryid: selectedCountry?.id,
          statecode: stateCode,
          // isocode : selectedCountry?.code + '-' + stateCode,
          statename: this.stateform.get('txtStateName').value,
          gstalise: this.stateform.get('txtGstAlise').value,
          status: this.stateform.get('txtStatus').value
        }
        // console.log("reqObj", requestObj);
        this.ngxLoaderService.start();
        this.geoService.updateState(requestObj).subscribe((res) => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.openConfirmationDialog("Record Updated Successfully");
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.data?.err_msg, "Error", 'error')
          }
        });
      }
    }
    catch (err) {
      console.error(err);
    }
  }


  bindCountries() {
    try {
      this.geoService.GetAllCountries().subscribe((res) => {
        if (res && res.success) {
          const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
          const defaultCountryCode = metaInfo.defaultcountry;

          if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
            this.countryList = res.data;
          } else if (metaInfo.operationtype.includes('Domestic')) {
            this.countryList = res.data.filter(item => item.isocode === defaultCountryCode);
            this.stateform.get('ddlCountry').setValue(defaultCountryCode);
            this.stateform.get('ddlCountry').disable();
          } else if (metaInfo.operationtype.includes('International')) {
            this.countryList = res.data.filter(item => item.isocode !== defaultCountryCode);
          } else {
            this.countryList = res.data;
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }


  warningDialog(msg: any) {
    Swal.fire({
      // title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  async openConfirmationDialog(msg: any) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.router.navigate(['/setup/geo/states'])
    }
  }




}
